<div class="row p-5">
  <div class="col-12 d-flex justify-content-center">
    <div class="not-found-img"></div>
  </div>
  <div class="pt-2 col-12 d-flex justify-content-center">
    <div class="error-description"
         i18n="@@bn-error-state-couldnt-load.page-couldnt-load">
      Page couldn’t load
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center">
    <div class="error-instructions"
         i18n="@@bn-error-state-couldnt-load.try-to-reload-page">
      Try to reload the page or contact the system administrator.
    </div>
  </div>
</div>
